// extracted by mini-css-extract-plugin
export default {"label":"styles_label__o8DZG","value":"styles_value__ExRft"};